import type { EnrollmentNavigationState } from '@/router/localEnrollmentNavigation'

export type InternalEnrollmentPath =
  | '/application'
  | '/endorsements'
  | '/request-call'
  | '/schedule'
  | '/self-enroll'
  | '/thank-you'

export const INTERNAL_PATH_ALIASES: Record<string, InternalEnrollmentPath> = {
  '/': '/application',
  '/application': '/application',
  '/endorsements': '/endorsements',
  '/enrollment': '/application',
  '/options': '/application',
  '/orientation': '/application',
  '/request-call': '/request-call',
  '/schedule': '/schedule',
  '/self-enroll': '/self-enroll',
  '/thank-you': '/thank-you'
}

export function normalizeInternalEnrollmentPath(pathname: string): InternalEnrollmentPath {
  return INTERNAL_PATH_ALIASES[pathname] ?? '/application'
}

export function getSearchParamSessionToken(searchParams: URLSearchParams) {
  return searchParams.get('sessionToken')?.trim() || ''
}

export function getInitialInternalLocation(state: EnrollmentNavigationState | null) {
  const sponsoredPath =
    typeof state?.sponsoredEnrollPath === 'string' ? state.sponsoredEnrollPath : '/application'
  const sponsoredState =
    state?.sponsoredEnrollState &&
    typeof state.sponsoredEnrollState === 'object' &&
    !Array.isArray(state.sponsoredEnrollState)
      ? (state.sponsoredEnrollState as EnrollmentNavigationState)
      : state
  const sponsoredSearch =
    typeof state?.sponsoredEnrollSearch === 'string' ? state.sponsoredEnrollSearch : ''

  return {
    pathname: normalizeInternalEnrollmentPath(sponsoredPath),
    searchStr: sponsoredSearch,
    state: sponsoredState ?? null
  }
}
